<template>
  <FieldValidator :name="name">
    <template v-slot="{ value, handleChange, isInvalid, errorMessage }">
      <Checkbox
        :id="`checkbox-field-${name}`"
        :binary="true"
        :modelValue="value"
        @update:modelValue="handleChange"
        :class="{ 'p-invalid': isInvalid }"
        v-bind="$attrs"
      >
        <template v-if="labelTop" #labelTop>{{ labelTop }}</template>
        <template v-if="label" #label>{{ label }}</template>
        <template v-if="valueText" #valueText>{{ valueText }}</template>
        <template v-if="isInvalid" #helperText>{{ errorMessage }}</template>
      </Checkbox>
    </template>
  </FieldValidator>
</template>

<script setup lang="ts">
import { Checkbox } from '../../../core/controls';
import { FieldValidator } from '../field-validator';

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
  labelTop: {
    type: String,
  },
  valueText: {
    type: String,
  },
});
</script>
